export default function (widgetID, widgetOptions) {
  const widgetName = widgetID;
  const widgetOpts = widgetOptions;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function () {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (cards.length < 1) {
        $('.custom-countdown').remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
